export type InitAction = { type: '@@INIT' };
export const INIT_ACTION: InitAction = { type: '@@INIT' };
